import { render } from "./income-report.vue?vue&type=template&id=0b506db6"
import script from "./income-report.vue?vue&type=script&lang=js"
export * from "./income-report.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__